import { useState, useEffect } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import TabPanel from './TabPanel';
import { setTabOnFocus } from '../../store/global/actions';
import { useDispatch, useSelector } from 'react-redux';
import { getTabOnFocus } from '../../store/global/selectors';
import { Grid } from '@material-ui/core';
import Deployment from "../pages/deployment";
import Page from '../atoms/page';
import SimulationConfiguration from '../pages/simulationConfiguration';
import { getDetailsFromUrl } from '../../services/blueprint';
import GitConfiguration from '../molecules/gitConfiguration/GitConfiguration';
import PlatformSchemaConfiguration from '../molecules/platformSchema/PlatformSchemaConfiguration'


export default function SimulationTabs(props) {
    const browserTabTitle =  props?.browserTabTitle;
    const dispatch = useDispatch();
    const tabOnFocus = useSelector(getTabOnFocus);
    const [openTab, setOpenTab] = useState(0);
    
    const { blueprintId } = getDetailsFromUrl();
    const showGitConfiguration = blueprintId !== undefined ? true : false;
    // console.log({showGitConfiguration})

    useEffect(() => {
        setOpenTab(tabOnFocus);
    }, [tabOnFocus])


    // useEffect(() => {
    //     dispatch(triggerTour({currentTour: 'configurations'}))
    // },[])

    return (
        <Page title={browserTabTitle != undefined ? browserTabTitle : "Configurations"} style={{ marginTop123: "-64px" }}>
            <Grid container direction={"row"}>
                <AppBar position="static">
                    <Tabs value={openTab} onChange={(e, v) => { dispatch(setTabOnFocus(v)); setOpenTab(v) }} aria-label="ConfigurationTabs">
                        <Tab label="Deployment Configuration" id="deployment_config_tab" data-ui-tour-id="deployment_config_tab" style={{textTransform: 'capitalize'}} />
                        <Tab label="Simulation Configuration" id="simulation_config_tab" data-ui-tour-id="simulation_config_tab" style={{textTransform: 'capitalize'}} />
                        <Tab label="Platform Schema Configuration" id="platform_schema_config_tab" data-ui-tour-id="platform_schema_config_tab" style={{textTransform: 'capitalize'}} />

                        {showGitConfiguration && <Tab label="Git Configuration" id="git_config_tab" style={{textTransform: 'capitalize'}} />}
                        
                    </Tabs>
                </AppBar>


                <TabPanel value={openTab} index={0} style={{width: '100%'}}>
                    <Deployment />
                </TabPanel>

                <TabPanel value={openTab} index={1} style={{width: '100%'}}>
                    <SimulationConfiguration/>
                </TabPanel>

                <TabPanel value={openTab} index={2} style={{width:'100%'}}>
                    <PlatformSchemaConfiguration />
                </TabPanel>

                {showGitConfiguration &&  
                <TabPanel value={openTab} index={3} style={{width: '100%'}}>
                    <GitConfiguration/>
                </TabPanel>
                }

                

            </Grid>
        </Page>
    )
}